import React, { Component } from 'react';
import { fileName, fileUrl } from '../../../../../util/file_url';
export default class AudioDisplay extends Component {
    render() {
        return (
            <div id="attachment-form-preview" className="flex-column-centered max-size">
                <div className="flex-column-centered">
                    <audio preload="metadata" src={fileUrl(this.props.filename)} controls />
                    <p className="legend" style={{ color: "white" }}>{fileName(this.props.filename)}</p>
                </div>
            </div>
        );
    }
};